export type JsonObject = Record<string, unknown>

export function jsonObject(value: unknown, message = "Server returned invalid JSON"): JsonObject {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error(message)
  return value as JsonObject
}

export function jsonArray(value: unknown, message = "Server returned invalid JSON") {
  if (!Array.isArray(value)) throw new Error(message)
  return value as unknown[]
}

export function jsonString(value: unknown, message = "Server returned invalid JSON") {
  if (typeof value !== "string") throw new Error(message)
  return value
}

export function jsonNumber(value: unknown, message = "Server returned invalid JSON") {
  if (typeof value !== "number" || !Number.isFinite(value)) throw new Error(message)
  return value
}

export function jsonBoolean(value: unknown, message = "Server returned invalid JSON") {
  if (typeof value !== "boolean") throw new Error(message)
  return value
}

export function optionalJsonString(value: unknown, message = "Server returned invalid JSON") {
  if (value === undefined) return undefined
  return jsonString(value, message)
}

export function stringArray(value: unknown, message = "Server returned invalid JSON") {
  return jsonArray(value, message).map((item) => jsonString(item, message))
}
